/**
 * Distintivo de estado.
 *
 * El color nunca lleva el significado solo: cada distintivo trae icono y
 * etiqueta de texto. Es lo que lo hace legible con daltonismo, impreso en
 * escala de grises y en modo de colores forzados.
 */

import type { StatusTone } from "./tones";

const ICONS: Record<StatusTone, string> = {
  good: "●",
  warning: "▲",
  serious: "◆",
  critical: "■",
  neutral: "○",
};

export function StatusBadge({
  tone,
  children,
}: {
  tone: StatusTone;
  children: React.ReactNode;
}) {
  return (
    <span className={`badge ${tone}`}>
      <span className="badge-icon" aria-hidden="true">
        {ICONS[tone]}
      </span>
      {children}
    </span>
  );
}
